/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSearchFilter } from './InternalApiSearchFilter';
import {
    InternalApiSearchFilterFromJSON,
    InternalApiSearchFilterFromJSONTyped,
    InternalApiSearchFilterToJSON,
    InternalApiSearchFilterToJSONTyped,
} from './InternalApiSearchFilter';
import type { InternalApiLogicalOperator } from './InternalApiLogicalOperator';
import {
    InternalApiLogicalOperatorFromJSON,
    InternalApiLogicalOperatorFromJSONTyped,
    InternalApiLogicalOperatorToJSON,
    InternalApiLogicalOperatorToJSONTyped,
} from './InternalApiLogicalOperator';
import type { InternalApiSortDirection } from './InternalApiSortDirection';
import {
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionFromJSONTyped,
    InternalApiSortDirectionToJSON,
    InternalApiSortDirectionToJSONTyped,
} from './InternalApiSortDirection';

/**
 * 
 * @export
 * @interface InternalApiFindCasesPageRequest
 */
export interface InternalApiFindCasesPageRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiFindCasesPageRequest
     */
    orderBy?: string;
    /**
     * 
     * @type {InternalApiSortDirection}
     * @memberof InternalApiFindCasesPageRequest
     */
    direction?: InternalApiSortDirection;
    /**
     * 
     * @type {Array<InternalApiSearchFilter>}
     * @memberof InternalApiFindCasesPageRequest
     */
    filters: Array<InternalApiSearchFilter>;
    /**
     * 
     * @type {InternalApiLogicalOperator}
     * @memberof InternalApiFindCasesPageRequest
     */
    logicalOperator: InternalApiLogicalOperator;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFindCasesPageRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFindCasesPageRequest
     */
    size: number;
}



/**
 * Check if a given object implements the InternalApiFindCasesPageRequest interface.
 */
export function instanceOfInternalApiFindCasesPageRequest(value: object): value is InternalApiFindCasesPageRequest {
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('logicalOperator' in value) || value['logicalOperator'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function InternalApiFindCasesPageRequestFromJSON(json: any): InternalApiFindCasesPageRequest {
    return InternalApiFindCasesPageRequestFromJSONTyped(json, false);
}

export function InternalApiFindCasesPageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFindCasesPageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'direction': json['direction'] == null ? undefined : InternalApiSortDirectionFromJSON(json['direction']),
        'filters': ((json['filters'] as Array<any>).map(InternalApiSearchFilterFromJSON)),
        'logicalOperator': InternalApiLogicalOperatorFromJSON(json['logicalOperator']),
        'page': json['page'],
        'size': json['size'],
    };
}

export function InternalApiFindCasesPageRequestToJSON(json: any): InternalApiFindCasesPageRequest {
    return InternalApiFindCasesPageRequestToJSONTyped(json, false);
}

export function InternalApiFindCasesPageRequestToJSONTyped(value?: InternalApiFindCasesPageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': value['orderBy'],
        'direction': InternalApiSortDirectionToJSON(value['direction']),
        'filters': ((value['filters'] as Array<any>).map(InternalApiSearchFilterToJSON)),
        'logicalOperator': InternalApiLogicalOperatorToJSON(value['logicalOperator']),
        'page': value['page'],
        'size': value['size'],
    };
}

